module.exports = __webpack_public_path__ + "static/media/default-img.74f1db99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-img.svg
// module id = 412
// module chunks = 49